<template>
  <div>
    <!-- <b-button size="sm" variant="outline-success" :to="{ name: 'admin-user' }">
      Voltar
    </b-button> -->

    <b-card>
      <b-tabs>
        <b-tab title="Assinatura">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <!-- <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="_id" placeholder="ID" v-model="form._id" disabled />
                  <label for="_id">ID</label>
                </div>
              </b-col> -->
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="code" placeholder="Código" v-model="form.code" />
                  <label for="code">Código</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="terminal_id" placeholder="Teminal ID" v-model="form.terminal_id" />
                  <label for="terminal_id">Terminal ID</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="content_id" placeholder="Conteúdo ID" v-model="form.content_id" />
                  <label for="content_id">Conteudo ID</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <label for="origin-list">Origem</label>
                  <b-form-group label="Origem" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.origin"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="origins"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="namePtBr" placeholder="Nome PT-BR" v-model="form.namePtBr" />
                  <label for="name">Nome PT-BR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameEnEu" placeholder="Nome EN-EU" v-model="form.nameEnEu" />
                  <label for="name">Nome EN-EU</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameEsEs" placeholder="Nome ES-ES" v-model="form.nameEsEs" />
                  <label for="name">Nome ES-ES</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameEsAr" placeholder="Nome ES-AR" v-model="form.nameEsAr" />
                  <label for="name">Nome ES-AR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="namePtPt" placeholder="Nome PT-PT" v-model="form.namePtPt" />
                  <label for="namePtPt">Nome PT-PT</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="nameZhCn" placeholder="Nome ZH-CN" v-model="form.nameZhCn" />
                  <label for="nameZhCn">Nome Zh-CN</label>
                </div>
              </b-col>

              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <span class="lbl-form-send-news">Conteudo PT-BR</span>
                  <v-select
                    id="tags-list"
                    placeholder="Conteudo PT-BR"
                    v-model="form.contentPtBr"
                    :options="[]"
                    multiple
                    pill
                    :taggable="true"
                    :push-tags="true"
                    :closeOnSelect="false"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <span class="lbl-form-send-news">Conteudo EN-EU</span>
                  <v-select
                    id="tags-list"
                    placeholder="Conteudo EN-EU"
                    v-model="form.contentEnEu"
                    :options="[]"
                    multiple
                    pill
                    :taggable="true"
                    :push-tags="true"
                    :closeOnSelect="false"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <span class="lbl-form-send-news">Conteudo ES-ES</span>
                  <v-select
                    id="tags-list"
                    placeholder="Conteudo ES-ES"
                    v-model="form.contentEsEs"
                    :options="[]"
                    multiple
                    pill
                    :taggable="true"
                    :push-tags="true"
                    :closeOnSelect="false"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <span class="lbl-form-send-news">Conteudo ES-AR</span>
                  <v-select
                    id="tags-list"
                    placeholder="Conteudo ES-AR"
                    v-model="form.contentEsAr"
                    :options="[]"
                    multiple
                    pill
                    :taggable="true"
                    :push-tags="true"
                    :closeOnSelect="false"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <span class="lbl-form-send-news">Conteudo PT-PT</span>
                  <v-select
                    id="tags-list"
                    placeholder="Conteudo PT-PT"
                    v-model="form.contentPtPt"
                    :options="[]"
                    multiple
                    pill
                    :taggable="true"
                    :push-tags="true"
                    :closeOnSelect="false"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <span class="lbl-form-send-news">Conteudo ZH-CN</span>
                  <v-select
                    id="tags-list"
                    placeholder="Conteudo PT-PT"
                    v-model="form.contentZhCn"
                    :options="[]"
                    multiple
                    pill
                    :taggable="true"
                    :push-tags="true"
                    :closeOnSelect="false"
                  >
                    <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span>
                  </v-select>
                </div>
              </b-col>
              <b-col md="12"></b-col>
              
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="linkPtBr" placeholder="Link PT-BR" v-model="form.linkPtBr" />
                  <label for="linkPtBr">Link PT-BR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="linkEnEu" placeholder="Link EN-EU" v-model="form.linkEnEu" />
                  <label for="linkEnEu">Link EN-EU</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="linkEsEs" placeholder="Link ES-ES" v-model="form.linkEsEs" />
                  <label for="linkEsEs">Link ES-ES</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="linkEsAr" placeholder="Link ES-AR" v-model="form.linkEsAr" />
                  <label for="linkEsAr">Link ES-AR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="linkPtPt" placeholder="Link PT-PT" v-model="form.linkPtPt" />
                  <label for="linkPtPt">Link PT-PT</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input id="linkZhCn" placeholder="Link ZH-CN" v-model="form.linkZhCn" />
                  <label for="linkZhCn">Link ZH-CN</label>
                </div>
              </b-col>
              <b-col md="12"></b-col>

              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-textarea
                    placeholder="Descrição PT-BR"
                    rows="2"
                    v-model="form.descPtBr"
                    autocomplete="off"
                    debounce="250"
                  />
                  <label for="descPtBr">Descrição PT-BR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-textarea
                    placeholder="Descrição EN-EU"
                    rows="2"
                    v-model="form.descEnEu"
                    autocomplete="off"
                    debounce="250"
                  />
                  <label for="descEnEu">Descrição EN-EU</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-textarea
                    placeholder="Descrição ES-ES"
                    rows="2"
                    v-model="form.descEsEs"
                    autocomplete="off"
                    debounce="250"
                  />
                  <label for="descEsEs">Descrição ES-ES</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-textarea
                    placeholder="Descrição ES-AR"
                    rows="2"
                    v-model="form.descEsAr"
                    autocomplete="off"
                    debounce="250"
                  />
                  <label for="descEsAr">Descrição ES-AR</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-textarea
                    placeholder="Descrição PT-PT"
                    rows="2"
                    v-model="form.descPtPt"
                    autocomplete="off"
                    debounce="250"
                  />
                  <label for="descPtPt">Descrição PT-PT</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-textarea
                    placeholder="Descrição ZH-CN"
                    rows="2"
                    v-model="form.descZhCn"
                    autocomplete="off"
                    debounce="250"
                  />
                  <label for="descZhCn">Descrição ZH-CN</label>
                </div>
              </b-col>
              
              <b-col md="12"><hr></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-group label="Tipo de sistema (Platform)" label-for="origin-list">
                  <v-select
                    id="origin-list"
                    v-model="form.system_type"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="system_type"
                    label="name"
                    :reduce="option => option.id"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
                </div>
              </b-col>
              <b-col md="12"><hr></b-col>

              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-delete"
                    placeholder="Data Desativação"
                    v-model="form.dt_delete"
                    disabled
                  />
                  <label for="dt-delete">Data Desativação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-delete"
                    placeholder="Email Desativação"
                    v-model="form.email_delete"
                    disabled
                  />
                  <label for="email-delete">Email Desativação</label>
                </div>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="active" name="active" checked="true" v-model="form.active">
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="displayPlatformPlans" name="displayPlatformPlans" checked="false" v-model="form.displayPlatformPlans">
                    Mostrar na pagina de planos da Plataforma Safras
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox id="displayPublicArea" name="displayPublicArea" checked="false" v-model="form.displayInPublicArea">
                    Habilitar na área pública
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              
              <b-col>
                <b-button type="submit" variant="primary" class="mr-1" @click="onSubmit">
                  Enviar
                </b-button>
                <b-button
                  variant="danger"
                  class="mr-1"
                  @click="onBackPage"
                >
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
  BFormTextarea
} from "bootstrap-vue";
import dropdownService from "@/providers/dropdownService";
import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import vSelect from "vue-select";
import AppConstants from '@/appConstants';
import clientSignatureService from '@/providers/clientSignatureService';

export default {
  props: {},
  data() {
    return {
      dataID: null,
      origins: [],
      system_type: [],
      form: {
        _id: "",
        code: "",
        terminal_id: "",
        content_id: "",
        namePtBr: "",
        nameEnEu: "",
        nameEsEs: "",
        nameEsAr: "",
        namePtPt: "",
        nameZhCn: "",
        linkPtBr: "",
        linkEnEu: "",
        linkEsEs: "",
        linkEsAr: "",
        linkPtPt: "",
        linkZhCn: "",
        descPtBr: "",
        descEnEu: "",
        descEsEs: "",
        descEsAr: "",
        descPtPt: "",
        descZhCn: "",
        contentPtBr: [],
        contentEnEu: [],
        contentEsEs: [],
        contentEsAr: [],
        contentPtPt: [],
        contentZhCn: [],
        active: true,
        dt_create: "",
        dt_update: "",
        dt_delete: "",
        email_create: "",
        email_update: "",
        email_delete: "",
        displayPlatformPlans: false,
        displayInPublicArea: false,
        system_type: ""
      },
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Novo Conteúdo');
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      // console.log("dataid: ", this.dataID);
    }

    this.loadData();
  },
  watch: {
    "form.namePtBr"(val) {
      if (val) {
        this.$store.dispatch("admin/updatePageTitle", val);
      } else {
        this.$store.dispatch("admin/updatePageTitle", 'Nova Assinatura');
      }
    },
  },
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_CLIENT_SIGNATURE);
    },
    onSubmit() {
      clientSignatureService
        .registerClientSignature(this.form, new URLSearchParams())
        .then(() => {
          // console.log(res);
          if (this.isUpdate) {
            messagesNotifyHelper.updatedRecordNotify();
          } else {
            messagesNotifyHelper.createdRecordNotify();
            this.onBackPage();
          }
        })
        .catch((err) => console.log(err));
    },
    getClientSignatureDetails() {
      const params = new URLSearchParams();
      clientSignatureService
        .getClientSignatureDetails(this.dataID, params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.code = res.code;
          this.form.terminal_id = res.terminal_id;
          this.form.content_id = res.content_id;
          this.form.namePtBr = res.namePtBr;
          this.form.nameEnEu = res.nameEnEu;
          this.form.nameEsEs = res.nameEsEs;
          this.form.nameEsAr = res.nameEsAr;
          this.form.namePtPt = res.namePtPt;
          this.form.nameZhCn = res.nameZhCn;
          
          this.form.linkPtBr = res.linkPtBr;
          this.form.linkEnEu = res.linkEnEu;
          this.form.linkEsEs = res.linkEsEs;
          this.form.linkEsAr = res.linkEsAr;
          this.form.linkPtPt = res.linkPtPt;
          this.form.linkZhCn = res.linkZhCn;
          
          this.form.descPtBr = res.descPtBr;
          this.form.descEnEu = res.descEnEu;
          this.form.descEsEs = res.descEsEs;
          this.form.descEsAr = res.descEsAr;
          this.form.descPtPt = res.descPtPt;
          this.form.descZhCn = res.descZhCn;
          
          this.form.contentPtBr = res.contentPtBr;
          this.form.contentEnEu = res.contentEnEu;
          this.form.contentEsEs = res.contentEsEs;
          this.form.contentEsAr = res.contentEsAr;
          this.form.contentPtPt = res.contentPtPt;
          this.form.contentZhCn = res.contentZhCn;

          this.form.origin = res.origin;
          this.form.system_type = res.system_type;

          this.form.active = res.active;
          this.form.displayPlatformPlans = res.displayPlatformPlans;
          this.form.displayInPublicArea = res.displayInPublicArea;
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(res.dt_create);
          this.form.dt_update = res.dt_update ? convertDatetimeHelper.convertStringToDateTime(res.dt_update) : res.dt_update;
          this.form.dt_delete = res.dt_delete ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete) : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      Promise.all([
        dropdownService.getAllOrigin(new URLSearchParams()),
        dropdownService.getPlatformSystemType(new URLSearchParams()),
      ]).then((res) => {
          this.origins = res[0];
          this.system_type = res[1];
          if (this.isUpdate) {
            this.getClientSignatureDetails();
          }
        })
        .catch((err) => console.log(err));
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BTabs,
    BTab,
    BCard,
    vSelect,
    BFormTextarea
  },
};
</script>

<style lang="scss">
</style>